const styles = {
  row: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    p: 0,
    m: 0,
  },
  column: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
    p: 0,
    m: 0,
  },
  bydb: {
    main: {
      position: 'relative',
      width: ['100dvw', null, '390px'],
      height: '100%',
      minHeight: '100dvh',
      boxShadow: '0px 0px 10px 5px rgba(0,0,0,.3)',

      '&.visible': {
        display: 'flex',
        visibility: 'visible',
      },
    },
    content: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      height: '100%',
      p: 0,
      m: 0,
      px: '16px',
      zIndex: 3,
    },
    bgImage: {
      position: 'relative',
      backgroundColor: 'bydb-black',
      backgroundImage: `linear-gradient(
          180deg,
          rgba(0, 0, 0, 1) 2%,
          rgba(0, 0, 0, 0) 5%,
          rgba(0, 0, 0, 0) 67%,
          rgba(0, 0, 0, 1) 75%,
          rgba(0, 0, 0, 1) 100%
        ), url(/static/images/bydb/2025/selection/background.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      boxShadow: '0px 0px 10px 5px rgba(0,0,0,.3)',
      backgroundSize: 'cover',
      minHeight: '100dvh',
      width: ['100dvw', '390px'],

      '&::after': {
        content: "''",
        position: 'fixed',
        top: 0,
        left: '50%',
        width: ['100dvw', '390px'],
        bottom: 0,
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(0, 0, 0, 0.8 )',
        zIndex: 1,
      },
    },

    foregroundContainer: {
      position: 'relative',
      zIndex: 2,
      padding: '0px 16px',
    },
  },
}

export default styles
